import { template as template_0ac7abfa7f8846f794b4054cdbebc774 } from "@ember/template-compiler";
import Control from 'ember-bootstrap/components/bs-form/element/control';
import { service } from '@ember/service';
import EmberFlatpickr from 'ember-flatpickr/components/ember-flatpickr';
import isKey from 'ember-keyboard/utils/is-key';
export default class DatePickerControl extends Control {
    @service
    intl;
    get locale() {
        const locale = this.intl.primaryLocale;
        if (locale === 'en-us') {
            return null;
        }
        return locale.replace(/-.*/, '');
    }
    onChange = ([date])=>{
        this.args.onChange?.(date);
    };
    handleKeyDown = (selectedDates, dateStr, instance, event)=>{
        if (isKey('keydown:Backspace', event) || isKey('keydown:Delete', event)) {
            this.args.onChange?.(null);
        }
    };
    static{
        template_0ac7abfa7f8846f794b4054cdbebc774(`
    <EmberFlatpickr
      class='ember-bootstrap-date-picker {{this.formValidationClass}}'
      @allowInput={{@allowInput}}
      @altInput={{@altInput}}
      @enableTime={{@enableTime}}
      @disabled={{@disabled}}
      @date={{@value}}
      @noCalendar={{@noCalendar}}
      @locale={{this.locale}}
      @dateFormat={{@dateFormat}}
      @onKeyDown={{this.handleKeyDown}}
      @onChange={{this.onChange}}
      ...attributes
    />
    {{yield}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
